export class CurrencyAmount {
    currencyCode: string;
    amount: number;
    unitName: string;
}
